import { Button } from "@/components/common";

export interface TableAddButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const TableAddButton = ({ children, onClick, disabled, className }: TableAddButtonProps) => {
  return (
    <Button leading="Add" onClick={onClick} disabled={disabled} className={className}>
      {children}
    </Button>
  );
};
